export enum BadgeStatus {
  Danger = 'Danger',
  Warning = 'Warning',
  Caution = 'Caution',
  Healthy = 'Healthy',
  Information = 'Information',
}

interface BadgeDotProps {
  status?: BadgeStatus;
  size?: 12 | 8;
  colorMap?: Partial<Record<BadgeStatus, string>>; // Allow the color map to be wholly or partially overridden.
}

export const statusColorMap: Record<BadgeStatus, string> = {
  [BadgeStatus.Danger]: 'var(--static-red-500)',
  [BadgeStatus.Warning]: 'var(--static-orange-500)',
  [BadgeStatus.Caution]: 'var(--static-yellow-500)',
  [BadgeStatus.Healthy]: 'var(--static-green-500)',
  [BadgeStatus.Information]: 'var(--static-grey-500)',
};

export function BadgeDot({ status = BadgeStatus.Danger, size = 12, colorMap }: BadgeDotProps) {
  const radius = size / 2;

  // Use the default color map as a fallback for an undefined or partial colorMap prop.
  const fill = colorMap?.[status] ?? statusColorMap[status];

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
    >
      <circle cx={radius} cy={radius} r={radius} fill={fill} />
    </svg>
  );
}

export default BadgeDot;
